<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.monthPlanVersion"
                selectType="selectSearch"
                requestApi="/scp/sopMonthPlan/monthPlanVersionPullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="version"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <a-select show-search option-filter-prop="children" v-model="queryParams.productBroadCategory" >
                <!-- <a-select-option v-for="(item) in lookUpCode.craftCategoryOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option> -->
                <a-select-option v-for="(item) in lookUpCode['SCP_PRODUCT_BROAD_CATEGORY']" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.status"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastStatus"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleSendAlert" type="primary">发布计划单</a-button>
      <a-button @click="handleSendAllAlert" type="primary">发布全部计划单</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
        >
          <span slot="monthPlanName" slot-scope="{ record }">
            <a @click="handleGoDetail(record)" class="ml10">{{ record.monthPlanName }}</a>
          </span>
          <template slot="netSubInventory" slot-scope="{ record }">
            <a-switch :disabled="false" :checked="record.netSubInventory === 'Y'" @change="statusOnChange(record)" />
          </template>
          <span slot="status" slot-scope="{ record }">
            <a @click="handleGoStatus(record)" class="ml10">{{ record.status }}</a>
          </span>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="safeStockVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.safeStockVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.safeStockVersion"
              selectType="selectSearch"
              :setParams="{ monthStart: $moment(record.currentPeriod).format('YYYYMM') }"
              requestApi="/scp/sopRatioHead/versionCodePullDown"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="version"
            />
          </template>

          <template slot="sfcNameVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.sfcNameVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.sfcNameVersion"
              selectType="selectSearch"
              requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
              :setParams="{ monthStart: record.currentPeriod }"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="version"
            />

          </template>
          <template slot="vendorCapacityVersion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.vendorCapacityVersion }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.vendorCapacityVersion"
              selectType="selectSearch"
              :setParams="{ monthStart: $moment(record.currentPeriod).format('YYYYMM') }"
              requestApi="/scp/scpSopBasicData/versionList"
              :selectItem="{ value: 'realValue', label: 'label' }"
            />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:sopMonthPlan:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDel(record)" v-hasPermi="['scp:sopMonthPlan:remove']">删除</a>
            <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleSend(record)" v-hasPermi="['scp:sopMonthPlan:publishPlan']">发布</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <startCalculation
          ref="startCalculation"
        />
      </div>
    </template>

  </ls-table-layout>
</template>

        <script>
    import { generateLsTableResData } from '@/utils/util.js'
     import startCalculation from './components/startCalculation.vue'
     import { ApiUpdateSopMonthPlan, ApiSendSopMonthPlan, ApiStartCalculate, ApiStopCalculate, ApiDeleteSopMonthPlan, ApiSopMpProductionDemandDetail, ApipoReqLinesAll } from '@/api/scp/month-plan/month-plan.js'
     import moment from 'moment';

    export default {
      // eslint-disable-next-line
      name: 'productionDemandPage', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
      components: {
        startCalculation
      },
      computed: {
      // 其他计算属性
      // ...
      formattedParams () {
        return {
          monthStart: moment(this.currentPeriod).format("YYYYMM")
          // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
        };
      }
    },
      data () {
        return {
          moment: moment, // 在 data 中创建 moment 实例
          currentPeriod: '',
          isEdit: false,
          currentId: "",
          lookUpCode: { craftCategoryOptions: [] },
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(ApiSopMpProductionDemandDetail, true),
            pageCurrent: true
          },
          // 查询参数
          queryParams: {
              monthPlanName: undefined,
              monthPlanVersion: undefined,
              status: undefined
          },
          baseUomFlagOptions: [
            {
              dictLabel: '是',
              dictValue: 'Y'
            },
            {
              dictLabel: '否',
              dictValue: 'N'
            }
          ],
          // 表格字段
          columns: [
            {
              title: '物料编码',
              dataIndex: 'itemCode',
              align: 'center',
              width: 180
            },
            {
              title: '工艺大类',
              dataIndex: 'productBroadCategory',
              ellipsis: true,
              width: 120,
              align: 'center'
            },
            {
              title: '物料名称',
              dataIndex: 'itemName',
              ellipsis: true,
              width: 180,
              align: 'center'
            },
            {
              title: '规格描述',
              width: 180,
              dataIndex: 'specification',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '订单编码',
              width: 220,
              dataIndex: 'orderNumber',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '完成日期',
              width: 120,
              dataIndex: 'newDockDate',
              scopedSlots: { customRender: 'updateTime' },
              ellipsis: true,
              align: 'center'
            },
            {
              title: '数量',
              width: 120,
              dataIndex: 'newOrderQuantity',
              align: 'center'
            },
            {
              title: '状态',
              width: 180,
              dataIndex: 'status',
              ellipsis: true,
              align: 'center'
            }
          ]
        }
      },
      created () {
       // this.getLastSalesForecast()
       this.queryParams.monthPlanVersion = this.$route.params.version; // 从路由参数中获取 id 值

       // 工艺大类
       this.getLookUpCode('SCP_PRODUCT_BROAD_CATEGORY')
      },
      mounted () {
        this.onSearch()
      },
      methods: {
        handleSendAlert () {
          if (this.selectedRowKeys.length === 0) {
            this.$message.error('请选择计算项')
            return
          }
         const self = this
          this.$confirm({
            title: '提示',
            content: '你确定发布所选的计划单吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
                ApipoReqLinesAll({ idList: self.selectedRowKeys }).then((response) => {
                    if (response.code === 200) {
                        self.$message.success('发布成功')
                        self.onSearch()
                    } else {
                        self.$message.error(response.msg)
                    }
                })
            },
            onCancel () {
            }
          });
        },
        handleSendAllAlert () {
            const self = this
          this.$confirm({
            title: '提示',
            content: '你确定发布所有的计划单吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
                ApipoReqLinesAll(self.queryParams).then((response) => {
                    if (response.code === 200) {
                        self.$message.success('发布成功')
                        self.onSearch()
                    } else {
                        self.$message.error(response.msg)
                    }
                })
            },
            onCancel () {
            }
          });
        },
          getLookUpCode (code) {
             const self = this
              const lookupQueryParams = {
                  lookupType: code,
                  current: 1,
                  pageSize: 100
              }
              this.getLookupListData(lookupQueryParams).then().then(response => {
              // this.lookUpCode[code] = response.rows
              // debugger
             // self.lookUpCode.craftCategoryOptions = response.rows
               self.$set(this.lookUpCode, code, response.rows)
              })
          },
        resetQuery () {
          this.queryParams = {
              monthPlanName: undefined,
              monthPlanVersion: undefined,
              status: undefined,
              productBroadCategory: undefined
          }
          this.onSearch()
        },
        handleCalculation () {
          if (this.selectedRowKeys.length > 1) {
            this.$message.error('选项不能超过1项')
            return
          }
          if (this.selectedRowKeys.length === 0) {
            this.$message.error('请选择计算项')
            return
          }
          //  this.$refs.startCalculation.show();
          const id = this.selectedRowKeys[0]
          ApiStartCalculate({ id: id }).then((response) => {
            if (response.code === 200) {
              this.$message.success('启动计算成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        handleStopCalculation () {
          if (this.selectedRowKeys.length > 1) {
            this.$message.error('选项不能超过1项')
            return
          }
          if (this.selectedRowKeys.length === 0) {
            this.$message.error('请选择停止计算项')
            return
          }
          //  this.$refs.startCalculation.show();
          const id = this.selectedRowKeys[0]
          ApiStopCalculate({ id: id }).then((response) => {
            if (response.code === 200) {
              this.$message.success('终止计算成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        handleGoCapacityLoad () {
          /** 检查只能选择一个 */
          if (this.selectedRows.length > 1) {
            this.$message.error('产能负荷的选择项不能大于1')
            return
          }
          if (this.selectedRows.length === 0) {
            this.$message.error('请勾选其中一项')
            return
          }
          this.$router.push({ path: `/monthly-plan/capacityLoadPage/${this.selectedRows[0].monthPlanName}/${this.selectedRows[0].monthPlanVersion}/${this.selectedRows[0].id}` })
        },
        handleGocomparison () {
          this.$router.push({ path: `/shipmentForecastManagement/comparison/` })
        },
        handleDel (record) {
          const self = this
          this.$confirm({
            title: '提示',
            content: '你确定删除该记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              self.deleteShipmentForecast(record)
            },
            onCancel () {
            }
          });
        },
        handleSend (record) {
          // debugger
          if (record.status !== '已完成') {
            this.$message.error('尚未完成计算，请在完成计算后，再发布')
            return
          }
          const self = this
          this.$confirm({
            title: '提示',
            content: '你确定发布该记录吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              self.sendShipmentForecast(record)
            },
            onCancel () {
            }
          });
        },
        handleGoStatus (record) {
          this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
        },
        deleteShipmentForecast (record) {
          ApiDeleteSopMonthPlan({ id: record.id }).then((response) => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        sendShipmentForecast (record) {
          ApiSendSopMonthPlan({ id: record.id }).then((response) => {
            if (response.code === 200) {
              this.$message.success('发布成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        handleGoDetail (record) {
          this.$router.push({ path: `/monthly-plan/detail/${record.monthPlanName}/${record.monthPlanVersion}/${record.id}` })
        },
        handleEdit (record) {
          if (this.currentId && record.id !== this.currentId && this.isEdit) {
                this.$message.warning('请保存上次编辑的数据')
                return;
              }
              this.isEdit = true;
              this.currentId = record.id;
        },
        handleAdd () {
          this.$router.push({ path: `/monthly-plan/editPage/` })
        },
        /** 行选中 */
        selectedRowChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        // 表单搜索
        onSearch () {
          this.isEdit = false
          this.$refs.dataTable.searchParams = this.queryParams
          this.$refs.dataTable.getData()
        },
        // 编辑-保存
        handleSave (record) {
          // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          //   this.$message.warning('折换不能为空且需大于0')
          //   return
          // }
           ApiUpdateSopMonthPlan(record).then(response => {
              if (response.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
              } else {
                this.$message.error(response.msg)
              }
            })
        },
        // 取消
        handleCancel (record) {
          this.isEdit = false
          this.onSearch()
        },
        statusOnChange (record) {
          record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
        }
      }
    }
    </script>

   <style scoped lang="less">
    .ml10 {
      margin-left: 10px;
    }/deep/.ant-select{
    width: 150px;
  }
    </style>
